module.exports = __webpack_public_path__ + "img/TVER.6f22c107.png";